import React, { useEffect, useState } from 'react';
import {
  Alert, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, MenuItem, TextField,
} from '@mui/material';
import { rhAPI } from '../../services/api';
import { apiError } from '../../utils/format';
import { MOTIFS, todayIso } from '../../utils/rh';

/** Saisie / modification d'une absence. `value` : absence existante ou valeurs initiales. */
const AbsenceDialog = ({ open, value, employes, onClose, onSaved }) => {
  const [f, setF] = useState(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setError('');
      setF({ employe_id: '', date_debut: todayIso(), date_fin: '', motif: 'MALADIE', justifiee: true, commentaire: '', ...value });
    }
  }, [open, value]);

  if (!f) return null;
  const save = async () => {
    setSaving(true); setError('');
    try {
      const data = { ...f, date_fin: f.date_fin || f.date_debut };
      if (f.id) await rhAPI.updateAbsence(f.id, data); else await rhAPI.createAbsence(data);
      onSaved(f.id ? 'Absence modifiée' : 'Absence enregistrée');
    } catch (e) { setError(apiError(e)); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{f.id ? "Modifier l'absence" : 'Nouvelle absence'}</DialogTitle>
      <DialogContent sx={{ display: 'grid', gap: 2, pt: '8px !important' }}>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField select label="Employé" value={f.employe_id} required onChange={(e) => setF({ ...f, employe_id: e.target.value })}>
          {employes.map((e) => <MenuItem key={e.id} value={e.id}>{e.nom} {e.prenom} — {e.matricule}</MenuItem>)}
        </TextField>
        <TextField type="date" label="Du" value={f.date_debut} InputLabelProps={{ shrink: true }} required
          onChange={(e) => setF({ ...f, date_debut: e.target.value })} />
        <TextField type="date" label="Au (inclus)" value={f.date_fin || f.date_debut} InputLabelProps={{ shrink: true }}
          onChange={(e) => setF({ ...f, date_fin: e.target.value })} />
        <TextField select label="Motif" value={f.motif} onChange={(e) => setF({ ...f, motif: e.target.value, justifiee: e.target.value === 'INJUSTIFIEE' ? false : f.justifiee })}>
          {Object.entries(MOTIFS).map(([k, v]) => <MenuItem key={k} value={k}>{v}</MenuItem>)}
        </TextField>
        <FormControlLabel
          control={<Checkbox checked={f.justifiee} disabled={f.motif === 'INJUSTIFIEE'} onChange={(e) => setF({ ...f, justifiee: e.target.checked })} />}
          label="Justificatif reçu (certificat, autorisation…)" />
        <TextField label="Commentaire" value={f.commentaire || ''} multiline minRows={2} onChange={(e) => setF({ ...f, commentaire: e.target.value })} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annuler</Button>
        <Button variant="contained" disabled={saving || !f.employe_id} onClick={save}>Enregistrer</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AbsenceDialog;
